import { defineMessages } from 'react-intl';

export const i18n = defineMessages({
	disclaimerMessage: {
		id: 'ai-disclaimer.disclaimerMessage',
		defaultMessage: 'Uses AI. Verify results.',
		description:
			'The disclaimer text that can be applied to the footer of various ai features throughout Atlassian',
	},
});
